import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useContent } from "../lib/content";

export default function DocumentsPanel() {
  const { t } = useContent();
  const [items, setItems] = useState(null);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    api.get("/me/documents").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, []);

  const open = async (doc) => {
    const win = window.open("", "_blank");
    setOpening(doc.id);
    try {
      const { data } = await api.get(`/me/documents/${doc.id}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      if (win) win.location.href = url; else window.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      win?.close();
      toast.error("No se pudo abrir el documento");
    } finally { setOpening(null); }
  };

  if (!items) return <p className="text-zinc-500 text-sm">Cargando…</p>;
  if (!items.length) {
    return <p data-testid="documents-empty" className="text-zinc-500">{t("plat_docs_empty")}</p>;
  }
  return (
    <div className="space-y-3 max-w-3xl">
      {items.map((d) => (
        <button key={d.id} data-testid={`document-${d.id}`} onClick={() => open(d)}
          className="w-full flex items-center justify-between gap-4 text-left border border-white/10 hover:border-[#C9A25E]/50 px-5 py-4 transition-colors">
          <div className="flex items-center gap-4">
            <FileText className="text-[#C9A25E] shrink-0" size={22} />
            <div>
              <p className="text-white">{d.title}</p>
              <p className="text-xs text-zinc-500">{d.session_date.split("-").reverse().join("/")}</p>
            </div>
          </div>
          <span className="text-sm text-[#C9A25E]">{opening === d.id ? "Abriendo…" : "Ver PDF →"}</span>
        </button>
      ))}
    </div>
  );
}
